import { gql } from '@apollo/client';
import { WEB_USER_CONTACT_FRAGMENT } from 'graphql/webuser/WebUserFragments';

export const FOLDER_FRAGMENT = gql`
  fragment Folder on Document {
    id
    key
    name
  }
`;

export const SHARED_FOLDER_FRAGMENT = gql`
  fragment SharedFolder on Document {
    ...Folder
    creator
    sharedWith {
      ...WebUserContact
    }
  }
  ${FOLDER_FRAGMENT}
  ${WEB_USER_CONTACT_FRAGMENT}
`;
